import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import MaterialDivider from './MaterialDivider';

const AntibioticForm = ({ index, data }) => {
  const { 
    handleDelete, handleInputChange, formErrors
  } = useContext(MaterialsCaptureContext);

  return(
    <Box mt={4}>
      <MaterialDivider 
        index={index} 
        title={'Antibiotic'} 
        showDeleteIcon={true} 
        handleDelete={handleDelete} 
        deleteIndex={data?.index} 
      />

      <Grid container spacing={1} mt={1}>
        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Type"
            name={`type-${data?.index}`}
            value={data?.type}
            onChange={e => 
              handleInputChange(e, data?.index, 'type', e.target.value)
            }
            helperText={formErrors[`type-${data?.index}`]}
            error={`type-${data?.index}` in formErrors}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            varient="outlined"
            label="Concentration"
            name={`concentration-${data?.index}`}
            value={data?.concentration}
            onChange={e => 
              handleInputChange(e, data?.index, 'concentration', e.target.value)
            }
            helperText={formErrors[`concentration-${data?.index}`]}
            error={`concentration-${data?.index}` in formErrors}
            type='number'
            fullWidth
          />
        </Grid>
      </Grid>
    </Box>
  );
};

AntibioticForm.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default AntibioticForm;